var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.DispositivosNoSeriadosTotales,
        callback: function($$v) {
          _vm.DispositivosNoSeriadosTotales = $$v
        },
        expression: "DispositivosNoSeriadosTotales"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "div",
            { attrs: { align: "left" } },
            [
              _c(
                "FormFieldsContainer",
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", sm2: "", md2: "", "ml-2": "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.tipo.label,
                              items: _vm.equipos,
                              "item-text": "tipoeqname",
                              "item-value": "tipoeqid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.tipo.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.tipo, "value", $$v)
                              },
                              expression: "formFields.tipo.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", sm2: "", md2: "", "ml-2": "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.requerimiento.label,
                              items: _vm.requerimientos,
                              "item-text": "asigrequerimiento",
                              "item-value": "asignumero",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.requerimiento.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.requerimiento,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.requerimiento.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", sm2: "", md2: "", "ml-2": "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.cliente.label,
                              items: _vm.clientes,
                              "item-text": "asigcrm_cliente",
                              "item-value": "asigcrm_rutcli",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.cliente.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.cliente, "value", $$v)
                              },
                              expression: "formFields.cliente.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { xs3: "", sm3: "", md3: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-right botones-filtros mt-1" },
                          [
                            _c(
                              "v-btn",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.filtrar()
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { color: "#27488e" } }, [
                                  _vm._v("search")
                                ]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.clearFilters()
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { color: "#27488e" } }, [
                                  _vm._v("clear")
                                ]),
                                _vm._v("Limpiar")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Buscar", outlined: "" },
                        on: {
                          keyup: function($event) {
                            return _vm.gridApi.setQuickFilter(_vm.filtro)
                          }
                        },
                        model: {
                          value: _vm.filtro,
                          callback: function($$v) {
                            _vm.filtro = $$v
                          },
                          expression: "filtro"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("AgGridVue", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: {
                            click: function($event) {
                              return _vm.guardar()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }